import { put, race, select, take } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureIntelligentCreateAttachmentBatchActivityInfoAction, photoCaptureIntelligentUpdateAttachmentIterationBatchIdAction, photoCaptureUploadAttachmentsAction, PHOTO_CAPTURE_UPDATE_ATTACHMENTS_FAILURE, PHOTO_CAPTURE_UPDATE_ATTACHMENTS_SUCCESS } from '../actions';
import { IntelligentAssignmentSummary } from '../constants';
import { getAttachmentIterationInfo, getEstimatorContextState, getPhotoCaptureContextId } from '../selectors';
import { attachmentInfo, attachmentIteration } from '../utilities';
/**
 * Saga to handle batch upload logic for photo capture
 * @param batchId - The unique batch ID
 * @param currentBatch - The files in the current batch
 */
export function* intelligentPhotoCaptureBatchUploadSaga(batch, batchId) {
    try {
        if (batch.length === 0) {
            throw new Error(IntelligentAssignmentSummary.BATCH_FAILED_TO_UPLOAD);
        }
        yield put(photoCaptureIntelligentCreateAttachmentBatchActivityInfoAction(batchId, batch));
        const currentInProgressIteration = attachmentIteration.getInProgressIteration(yield select(getAttachmentIterationInfo));
        if (currentInProgressIteration !== undefined) {
            yield put(photoCaptureIntelligentUpdateAttachmentIterationBatchIdAction(currentInProgressIteration.iterationId, batchId));
        }
        const contextState = yield select(getEstimatorContextState);
        const { companyCode, attachmentBatchActivityInfo, estimatedSummaryFilesInfo } = contextState;
        const contextId = yield select(getPhotoCaptureContextId);
        const attachments = attachmentInfo.createAttachments(batch, attachmentBatchActivityInfo, estimatedSummaryFilesInfo);
        // Dispatch upload action
        yield put(photoCaptureUploadAttachmentsAction(attachments, contextId, companyCode));
        // Wait for the upload to complete before allowing another batch to be processed
        while (true) {
            // Wait for either a success or failure action related to attachment updates
            const { successAction, failureAction } = yield race({
                successAction: take(PHOTO_CAPTURE_UPDATE_ATTACHMENTS_SUCCESS),
                failureAction: take(PHOTO_CAPTURE_UPDATE_ATTACHMENTS_FAILURE)
            });
            if (successAction &&
                successAction.payload &&
                successAction.payload.updatedAttachments &&
                successAction.payload.updatedAttachments.length) {
                break;
            }
            if (failureAction &&
                failureAction.payload &&
                failureAction.payload.updatedAttachments &&
                failureAction.payload.updatedAttachments.length) {
                break;
            }
        }
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureBatchUploadSaga.js.map